/* eslint-disable sort-keys-fix/sort-keys-fix */
export const PermissionStatus = {
    PENDING: "pending",
    GRANTED: "granted",
    DENIED: "denied",
};
